import { Typography } from '@mui/joy';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import TranscriptCard from './transcriptCard';
import ViewTranscript from './viewTranscript';

import { useAppSelector } from '../../../../../../hooks/global/typedReduxHooks';
import { MeetingTranscript } from '../../../../../../slices/reportSlice';

import { Option, Select } from '~/components/ui/select';

enum TranscriptSorting {
  LATEST = 'LATEST',
  EARLIEST = 'EARLIEST',
}


function TranscriptionTab() {
  const [viewTranscript, setViewTranscript] = useState<MeetingTranscript>();
  const [transcriptSort, setTranscriptSort] = useState<TranscriptSorting>(
    TranscriptSorting.LATEST,
  );
  const meetingTranscripts = useAppSelector(
    (state) => state.reports.meetingTranscripts,
  );

  return (
    <Box
      sx={{
        overflowY: 'auto',
        height: '47vh',
        scrollbarWidth: 'thin',
        padding: '1rem 0px',
        '::-webkit-scrollbar': {
          width: '10px',
        },
        '::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '::-webkit-scrollbar-thumb': {
          bgcolor: 'rgba(155, 155, 155, 0.5)',
          borderRadius: ' 20px',
          border: ' transparent',
        },
      }}
    >
      <div className='mb-3 max-w-28'>
        <Select
          value={transcriptSort}
          onChange={(_event, value) => {
            setTranscriptSort(value as TranscriptSorting);
          }}
        >
          <Option value={TranscriptSorting.LATEST}>
            <FormattedMessage defaultMessage='Latest' />
          </Option>
          <Option value={TranscriptSorting.EARLIEST}>
            <FormattedMessage defaultMessage='Earliest' />
          </Option>
        </Select>
      </div>
      {_.isEmpty(meetingTranscripts) && (
        <div className='flex flex-row items-center justify-center pr-1'>
          <Typography>
            <FormattedMessage defaultMessage='No Transcription Found' />
          </Typography>
        </div>
      )}
      <div className='flex flex-col w-full pr-1 gap-2'>
        {[...meetingTranscripts]
          .sort((a, b) => {
            if (transcriptSort === TranscriptSorting.LATEST) {
              return dayjs(b.createdAt).diff(dayjs(a.createdAt));
            }

            return dayjs(a.createdAt).diff(dayjs(b.createdAt));
          })
          .map((transcript) => (
            <TranscriptCard
              key={transcript.id}
              title={transcript.title}
              date={transcript.createdAt.toString()}
              onClickView={() => {
                setViewTranscript(transcript);
              }}
              audioSource={transcript.audioSource}
            />
          ))}
      </div>
      <ViewTranscript
        open={!!viewTranscript}
        onClose={() => {
          setViewTranscript(undefined);
        }}
        meetingTranscript={viewTranscript}
      />
    </Box>
  );
}

export default TranscriptionTab;
